import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { paragraphRegular } from '@helpers/typography';
import SelectStyles from '@stories/Components/Misc/Forms/Inputs/Select/Select.styles';
import { ContentType } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
import FormStyles from '../../Misc/Forms/Form.styles';
const Container = styled(FormStyles.Field) `
  --textColour: ${brand.blue.navy};
  --borderColour: ${brand.green.default};

  &[data-type=${ContentType.Intermediaries}],
  &[data-type=${ContentType.Savings}] {
    --borderColour: ${brand.blue.navy};
  }

  ${SelectStyles.Select} {
    ${paragraphRegular};
    ${fonts.proximaNova.semiBold};

    margin: 0;
  }
`;
const Label = styled(FormStyles.Label) `
  margin-bottom: ${fluid(2, 6)};
`;
const SortByDropdownStyles = {
    Container,
    Label,
};
export default SortByDropdownStyles;
